import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PreviewUserHeadingServiceBase, UserHeading } from '../../services/preview-user-heading/preview-user-heading.service';
import { PageLayoutApiService } from '../../services/page-layout/page-layout-api.service';
import { AppConfig, ProductionTypes } from '@shared/utils/app-config';
import { NotificationBannerReadResponse } from '../../models/responses.models';
import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';
import { NotificationBannerReadRequest } from '../../models/request.models';

@Component({
    selector: 'feature-page-layout-notification-banner',
    templateUrl: './notification-banner.component.html',
    styleUrls: ['./notification-banner.component.css'],
    standalone: false
})
export class NotificationBannerComponent extends StaticPropsComponentExtensions implements OnInit {
  public user$: Observable<UserHeading>;
  private isNotificationBannerRead = false;

  constructor(private appConfig: AppConfig, private user: PreviewUserHeadingServiceBase, private pageLayoutApiService: PageLayoutApiService) {
    super();
    this.user$ = this.user.getUserData();
  }

  ngOnInit(): void {}

  showNotificationBanner(): Observable<boolean> {
    switch (this.appConfig.productionType) {
      case ProductionTypes.isPolice:
      case ProductionTypes.isPatroleyes:
      case ProductionTypes.isBeta:
        return of(!this.isNotificationBannerRead);
      default:
        return of(false);
    }
  }

  updateUserNotificationBannerRead(uid: string): void {
    const request = new NotificationBannerReadRequest(true);
    this.pageLayoutApiService.updateUserNotificationBannerRead(uid, request).subscribe((response: NotificationBannerReadResponse) => {
      this.isNotificationBannerRead = response.IsNotificationBannerRead;
    });
  }
}
